<template>
    <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="false"
    >
      
      <template #layoutContent>
        <Loader>
          <div class="card shadow-sm mb-5 p-5 px-10">
            <div class="d-flex justify-content-start align-items-center mt-2">  
              <h3 class="mt-1"> {{ currentCompany?.name }} </h3>
              <span class="ms-5"> {{$t('folder.selectCompanyDesc')}} </span>
            </div>
            <div class="row mt-5">
              <OfficeCountCard class="mb-4"  v-for="office in offices" :withCount="false" :key="office.id" :office="office" v-model="selectedOffice"/>
            </div>
          </div>
          
          <div class="row">
            <div class="col-12">
              <Card :title="$t('folder.list')">   
                <template #cardToolbar>
                  <Button
                      type="new"
                      btn-class="btn-sm mx-3"
                      btn-text="folder.create"
                      v-if="$can(abilities.CREATE_USER)"
                      @click.prevent="createEmployeFolder" />
                </template>
                <template #cardBody>
                  <div>
                    <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_employe_folder_datatable">
                      <thead>
                        <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                          <th class="min-w-100px text-center">{{ $t('folder.table.fullname') }}</th>
                          <th class="min-w-100px text-center">{{ $t('folder.table.email') }}</th>
                          <th class="min-w-100px text-center">{{ $t('folder.table.enterDate') }}</th>
                          <th class="min-w-100px text-center">{{ $t('folder.table.status') }} </th>
                          <th class="min-w-100px text-center">{{ $t('label.action') }}</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </template>
              </Card>
            </div>
          </div>
        </Loader>
      </template>
    </SubLayout>
  </template>
  <script setup>
  
  import Card from "@/components/Card.vue";
  import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
  import {useRoute, useRouter} from "vue-router";
  import {useStore} from "vuex";
  import {useLocales} from "@/composables/locales";
  import {computed, ref, watch, onMounted} from "vue";
  import Loader from "@/components/Loader.vue";
  import Button from "@/components/Button.vue";
  import abilities from "@/composables/abilities";
  import OfficeCountCard from "@/components/OfficeCountCard.vue";
  import { BASE_URL } from "@/services/api";
  import { useHasAbility } from "@/composables/hasAbility";
import { Theme } from "@/composables/theming";


  const route = useRoute()
  const router = useRouter()
  const store = useStore()
  const { locale,datatableLocaleUrl} = useLocales()
  const {can} = useHasAbility()
  
  const title = ref("breadcrumbs.folder.title")
  const breadcrumbs = ref([
    {
      name: 'breadcrumbs.folder.list',
      route: 'employe-folder'
    }
  ])
  const table = ref('')
  const selectedOffice = ref('')

   
  const offices = computed(() => (store.getters['offices/getSocietyOffices']))
  const currentCompany = computed(() => store.getters['offices/getSelectedCompany'])


  watch(() => currentCompany.value, (value) => {
    if(value){
     store.dispatch("offices/loadSocietyOffices", value?.id)
    }
  })

  watch(() => offices.value, (value) => {
    if(value){
      selectedOffice.value = value[0]?.id
    }
  })

  
  watch(() => selectedOffice.value, (value) => {
    if(selectedOffice.value){
      fetchDatas()
    }
  })
 

  const createEmployeFolder = () => {
    router.push({name: 'employe-folder-list-create'})
  }

  function fetchDatas() {
    const AUTH_TOKEN = Ls.get('auth.token')
    
    table.value = $("#kt_employe_folder_datatable").DataTable({
      destroy: true,
      responsive: !0,
      searchDelay: 500,
      processing: !0,
      serverSide: !0,
      pageLength: Ls.get('pageLength'),
      lengthMenu: [5, 10, 25, 50, 75, 100 ],
      order: [[ 0, 'desc']],
      ajax: {
        url: BASE_URL + `/get/employee/datatables?office_id=${selectedOffice.value}`,
        type: "GET",
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          request.setRequestHeader("Company", Ls.get('current.company'));
        },
      },
      columns: [
      { data: "firstname" }, { data: "email" }, { data: "date_in_service" }, { data: "status" }, { data: "Actions", responsivePriority: -1 }
      ],
      columnDefs: [
        {
          targets: -5,
          order: "desc",
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {
            return '<span data-id="'+ e.id +'">' + e.firstname + ' ' + e.lastname + "</span>";
          },
        },
        {
          targets: -4,
          order: "desc",
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {
            return '<span data-id="'+ e.id +'">' + t + "</span>";
          },
        },
        {
          targets: -3,
          order: "desc",
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {
            let date = t ? new Date(t)?.toLocaleDateString() : ''
            return '<span data-id="'+ e.id +'">' + date + "</span>";
          },
        },
        {
          targets: -2,
          orderable: false,
          className: "dt-center text-center" ,
          render: function (t, a, e, l) {
            return `
              <label class="form-check form-switch form-check-custom form-check-solid justify-content-center">
                <input 
                  class="form-check-input toggle-status-view" 
                  type="checkbox" 
                  data-id="${e.id}" 
                  ${t.value == 'ACTIVE' ? 'checked="checked"' : ""} 
                />
              </label>
            `
          },
        },
        {
          width: "10%",
          targets: -1,
          "className": "dt-center text-start",
          title: "Actions",
          orderable: !1,
          render: function (t, a, e, l) {
            let render = ""

            if(can(abilities.VIEW_USER)) {
              render+='<a href="javascript:;" data-id="'+ e.id +'"  class="btn btn-sm btn-clean btn-icon show_btn" title="'+ i18n.global.t('button.view') +'"><i  data-id="'+ e.id +'" class="fas fa-eye fs-2" style="color: '+Theme.gray +'"></i></a>'
              render+='<a href="javascript:;" data-id="'+ e.id +'"  class="btn btn-sm btn-clean btn-icon download_btn" title="'+ i18n.global.t('button.download') +'"><i  data-id="'+ e.id +'" class="fas fa-download fs-2" style="color: '+Theme.gray +'"></i></a>'
            }
            if(can(abilities.UPDATE_USER)) {
              render+='<a href="javascript:;" data-id="'+ e.id +'"  class="btn btn-sm btn-clean btn-icon edit_btn" title="'+ i18n.global.t('button.edit') +'"><i  data-id="'+ e.id +'" class="fa fa-edit fs-2"  style="color: '+Theme.gray +'"></i></a>'
            }
            if(can(abilities.DELETE_USER))  {
              render+='<a href="javascript:;" data-id="'+ e.id +'"  class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i  data-id="'+ e.id +'" class="fas fa-trash fs-2"  style="color: '+Theme.gray +'"></i></a>'
            }

            return render
          },
        },

      ],
      language: {
        url: datatableLocaleUrl.value,
      }
    });

   
    $(document).on("click", "#kt_employe_folder_datatable .show_btn", (e) => {
      let id = e.target.getAttribute('data-id')
      router.push({name: 'employe-folder-list-view', params: { id } })
    });

    $(document).on("click", "#kt_employe_folder_datatable .edit_btn", (e) => {
      let id = e.target.getAttribute('data-id')
      router.push({name: 'employe-folder-list-view', params: { id } })
    }); 

    $(document).on("click", "#kt_employe_folder_datatable .delete_btn", (e) => {
      let id = e.target.getAttribute('data-id')
     // deleteFolder(id)
    });

    $(document).on("change", "#kt_employe_folder_datatable .toggle-status-view", function (event) {
      const checkbox = event.target;
      const data = {
        id: checkbox.getAttribute("data-id"),
        is_active: checkbox.checked
      }

      changeStatus(data);
    });

    
  }
  

  async function changeStatus(data){
    
    store.dispatch('employes/changeStatus', data)
    .then((response) => {
      
      window.toastr['success'](i18n.global.t('notification.status_updated_successfully'))
    })
    .catch(err => {
    })
  }

  onMounted(async() => {
    
    if(currentCompany.value){
      store.dispatch("offices/loadSocietyOffices", currentCompany.value?.id)
    }

    if(selectedOffice.value){
      fetchDatas()
    }
    
  })
  
</script>

<style scoped>
  .table-container {
    height: 350px;
    overflow-y: auto;
  }

  thead th {
    position: sticky;
    top: 0;
    background-color: #f8f9fa;
    z-index: 1;
  }
</style>